import React, { Component, useEffect, useState } from "react";
import ComponentForgotPasswordConfirmationMobile from "./ComponentForgotPasswordConfirmationMobile";
import ComponentForgotPasswordConfirmationWeb from "./ComponentForgotPasswordConfirmationWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentForgotPasswordConfirmation = () => {
  const gaEventTracker = useAnalyticsEventTracker("ForgotPasswordGetOTP");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Forgot Password Get OTP",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentForgotPasswordConfirmationWeb></ComponentForgotPasswordConfirmationWeb>
      </BrowserView>
      <MobileView>
        <ComponentForgotPasswordConfirmationMobile></ComponentForgotPasswordConfirmationMobile>
      </MobileView>
    </>
  );
};

export default ComponentForgotPasswordConfirmation;
